import { createIcon } from "@chakra-ui/react";

// using `path`
export const CheckIcon = createIcon({
  displayName: "CheckIcon",
  viewBox: "0 0 448 512",
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: <path d="M448.1 118.2L437 129.7 173.6 404l-11.5 12-11.5-12L11.1 258.8 0 247.2l23.1-22.2 11.1 11.5L162.1 369.8 414 107.5 425 96l23.1 22.2z" />,
});
